module.exports = __webpack_public_path__ + "static/media/about_us_ill.b24998cd.png";